/**
 * Motifs d'annulation d'une inscription.
 *
 * En base, l'inscription reste une « Annulation » et le motif va dans
 * `learner_session.unsubscribed_comment` (« Motif de désinscription ») : chiffre
 * d'affaires, envois et taux d'annulation la comptent comme telle. À l'écran, on
 * affiche le motif à la place du mot « Annulation ».
 *
 * Les écrans gardent le statut réel pour leur logique (couleur, filtres, édition)
 * et n'utilisent learnerStatusLabel() que pour le libellé.
 */
export const CANCELLATION_REASONS = [
  'Budget insuffisant',
  'Arrêt maladie',
  'Session annulée',
  "PS demande l'annulation",
  'No show',
];

export const cancellationReasonOf = (status, comment) => (
  status === 'Annulation' && CANCELLATION_REASONS.includes(comment) ? comment : null
);

/** Libellé à afficher pour une inscription : le motif d'annulation s'il y en a un. */
export const learnerStatusLabel = (status, comment) => cancellationReasonOf(status, comment) || status;

/**
 * Enregistre un choix du menu Statut qui touche à l'annulation.
 *
 * Un motif = statut « Annulation » puis le motif. Une « Annulation » sans motif,
 * choisie après un motif, réécrit le motif en « Annulation » : l'API transforme une
 * valeur vide en « 0 », on ne peut donc pas le vider.
 *
 * @return {Promise<object>} les champs à reporter sur la ligne
 */
export const saveCancellation = async (editCustomer, learnerSessionId, value, previousStatus, previousComment, token) => {
  const reason = CANCELLATION_REASONS.includes(value) ? value : null;
  const comment = reason || (cancellationReasonOf(previousStatus, previousComment) ? 'Annulation' : null);
  await editCustomer(2, learnerSessionId, 'Annulation', token, 'status');
  if (comment) {
    await editCustomer(2, learnerSessionId, comment, token, 'unsubscribed_comment');
  }
  return comment ? { status: 'Annulation', unsubscribed_comment: comment } : { status: 'Annulation' };
};

/** Vrai si ce choix du menu Statut passe par saveCancellation(). */
export const isCancellationChoice = (value) => value === 'Annulation' || CANCELLATION_REASONS.includes(value);
